import React from 'react';
import { Typography } from '@mui/material';
import ModernwashListScreen from './modernwash/ModernwashListScreen';
import PaymentStatusBadge from '../../components/PaymentStatusBadge';
import { fetchModernwashRfCards } from '../../api/modernwash';
import { colors } from '../../design-system/tokens';
import { pick, formatWon, formatDate, formatDateTime } from './modernwash/format';

/**
 * RF 카드 — 세차장 자체 크레딧 카드 (read-only).
 * 원천에 데이터가 없으면 어댑터가 SOURCE_NO_DATA 를 주고, 화면은 "원천 데이터 없음"
 * 안내를 보여준다(SourceStatusBanner). 데이터가 생기면 아래 표로 그대로 표시된다.
 */
const COLUMNS = [
  {
    key: 'cardNumber',
    label: '카드 번호',
    render: (row) => (
      <Typography variant="body2" sx={{ fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}>
        {pick(row, ['cardNumber', 'cardNo', 'number', 'uid', 'rfId'], '-')}
      </Typography>
    ),
  },
  {
    key: 'balance',
    label: '잔액',
    align: 'right',
    render: (row) => (
      <Typography variant="body2" sx={{ fontVariantNumeric: 'tabular-nums' }}>
        {formatWon(pick(row, ['balance', 'credit', 'amount', 'remaining']))}
      </Typography>
    ),
  },
  {
    key: 'status',
    label: '상태',
    render: (row) => {
      const label = pick(row, ['statusLabel', 'status']);
      const active = pick(row, ['active', 'isActive', 'enabled']);
      if (label) {
        return <PaymentStatusBadge label={String(label)} status={active === false ? 'neutral' : 'success'} />;
      }
      return (
        <PaymentStatusBadge
          label={active === false ? '정지' : '사용 중'}
          status={active === false ? 'neutral' : 'success'}
        />
      );
    },
  },
  {
    key: 'issuedAt',
    label: '발급일',
    render: (row) => (
      <Typography variant="body2" sx={{ color: colors.text.secondary }}>
        {formatDate(pick(row, ['issuedAt', 'createdAt', 'registeredAt']))}
      </Typography>
    ),
  },
  {
    key: 'lastUsedAt',
    label: '최근 사용',
    render: (row) => (
      <Typography variant="body2" sx={{ color: colors.text.secondary, whiteSpace: 'nowrap' }}>
        {formatDateTime(pick(row, ['lastUsedAt', 'usedAt', 'lastTaggedAt']))}
      </Typography>
    ),
  },
];

const RfCards = () => (
  <ModernwashListScreen
    title="RF 카드"
    description="세차장에서 판매하는 RF 크레딧 카드예요. ModernWash 원천을 그대로 읽어 발급·잔액을 보여줍니다."
    fetcher={fetchModernwashRfCards}
    columns={COLUMNS}
    getRowKey={(row, index) =>
      pick(row, ['id', '_id', 'cardNumber', 'uid'], `rfcard-${index}`)
    }
    emptyText="발급된 RF 카드가 없어요."
    minWidth={680}
  />
);

export default RfCards;
